import { useMemo, useState } from 'react';
import { PRODUCTS, CURRENCIES } from '@/mocks/lot';

export type PipMode = 'auto' | 'manual';

export function useLotCalculator() {
  const [balance, setBalance] = useState(10000);
  const [risk, setRisk] = useState(1);
  const [pair, setPair] = useState('EURUSD');
  const [currency, setCurrency] = useState('USD');
  const [stopLoss, setStopLoss] = useState(50);
  const [pipMode, setPipMode] = useState<PipMode>('auto');
  const [manualPip, setManualPip] = useState(10);
  const [explanationOpen, setExplanationOpen] = useState(false);

  const product = useMemo(() => PRODUCTS.find((p) => p.value === pair) ?? PRODUCTS[0], [pair]);
  const curr = useMemo(() => CURRENCIES.find((c) => c.value === currency) ?? CURRENCIES[0], [currency]);

  const pipValue = pipMode === 'auto' ? product.pipValue * curr.rate : manualPip;
  const riskAmount = (balance * risk) / 100;
  const lotSize = stopLoss > 0 && pipValue > 0 ? riskAmount / (stopLoss * pipValue) : 0;

  const balanceInvalid = Number.isNaN(balance) || balance <= 0;
  const slInvalid = Number.isNaN(stopLoss) || stopLoss <= 0;
  const pipInvalid = pipMode === 'manual' && (Number.isNaN(manualPip) || manualPip <= 0);
  const hasError = balanceInvalid || slInvalid || pipInvalid;

  const riskPosition = Math.min(Math.max(risk / 5, 0), 1) * 100;
  const riskLevel = risk < 1 ? 'Thấp' : risk <= 2 ? 'Trung bình' : 'Cao';

  return {
    balance,
    setBalance,
    risk,
    setRisk,
    pair,
    setPair,
    currency,
    setCurrency,
    stopLoss,
    setStopLoss,
    pipMode,
    setPipMode,
    manualPip,
    setManualPip,
    product,
    curr,
    pipValue,
    riskAmount,
    lotSize,
    balanceInvalid,
    slInvalid,
    pipInvalid,
    hasError,
    riskPosition,
    riskLevel,
    explanationOpen,
    openExplanation: () => setExplanationOpen(true),
    closeExplanation: () => setExplanationOpen(false),
  };
}

export type LotCalculatorState = ReturnType<typeof useLotCalculator>;